module.exports = __webpack_public_path__ + "img/shiLin5.2deb8237.png";